import { FlaggableIngredient } from 'common/Constants';
import { isNil } from 'lodash';
import { DishTag, MealPlanFoodItemUpsellFragment } from 'src/gqlReactTypings.generated.d';
import { DietaryTags } from 'src/pages/consumer/components/DishModalRevamp/DietaryTags';
import { FoodItemTagChips } from 'src/pages/consumer/meal-plans/components/Chips/FoodItemTagChips';
import { UpsellLabelChip } from 'src/pages/consumer/meal-plans/components/Chips/UpsellChips';
import { FoodItemRatings } from 'src/pages/consumer/meal-plans/components/FoodItemRatings';
import { DietaryTags as DietaryTagsEnum } from 'web-common/src/shared/Enums';

interface IFoodTagsProps {
  dietaryTags: DietaryTagsEnum[];
  averageRating?: number;
  ratingCount?: number;
  foodItemId?: number;
  upsell?: MealPlanFoodItemUpsellFragment | null;
  ingredientsFlagged?: FlaggableIngredient[];
  customIngredientsFlagged?: string[];
  isSeedOilFree?: boolean | null;
  tags?: DishTag[] | null;
}

export const ModalV2FoodTags: React.FC<IFoodTagsProps> = ({
  dietaryTags,
  averageRating,
  ratingCount,
  foodItemId,
  upsell,
  ingredientsFlagged,
  customIngredientsFlagged,
  isSeedOilFree,
  tags,
}) => (
  <div className='no-scrollbar my-1.5 flex items-center gap-2 overflow-x-auto'>
    {!isNil(averageRating) && !isNil(ratingCount) && foodItemId != null && (
      <FoodItemRatings averageRating={averageRating} ratingCount={ratingCount} foodItemId={foodItemId} />
    )}
    {upsell && <UpsellLabelChip upsell={upsell} applyFullHeight />}
    <FoodItemTagChips isSeedOilFree={isSeedOilFree} tags={tags} />
    <DietaryTags
      dietaryTags={dietaryTags}
      ingredientsFlagged={ingredientsFlagged}
      customIngredientsFlagged={customIngredientsFlagged}
    />
  </div>
);
